const {loginUrl, languagesMenu} = require('../../utils');
const {languages, scrollDropdownWhenItemsAmountIsBiggerThen} = require('../../data/constants.json');
const {links} = require('../common');
const css = require('./desktop.scss');
const icons = {
  globe: require('../svg/globe').default,
  arrowDown: require('../svg/arrowDown').default
};

const dropdown = (items, {title = '', iconClass = '', icon = null} = {}) => `
  <button type="button" class="${css.icon} ${iconClass}" title="${title}">${icon || ''}</button>
  ${links(items, {
    list: items => items.length > scrollDropdownWhenItemsAmountIsBiggerThen ? [css.dropdown, css.limitHeight] : css.dropdown,
    item: css.dropdownItem,
    itemContent: css.dropdownItemContent
  })}
`;

module.exports = ({mainLinks, userLinks, user, t, config}) => `
  <a href="//wix.com/" class="${css.logo}" title="${t('title_wix_logo')}">
    <img src="${config.baseUrl}/assets/wix-black.svg" class="${css.logoImg}" alt="Wix">
  </a>
  <ul class="${css.navigation}">
    ${mainLinks.map(item => `
      <li class="${css.navigationItem}">
        <a href="${item.href}" class="${css.navigationItemContent}">${item.text}</a>
        ${item.subs && item.subs.length ? dropdown(item.subs, {title: '', icon: icons.arrowDown}) : ''}
      </li>
    `).join('')}
  </ul>
  ${user ? `
    <div class="${css.user}">
      <img src="${user.profileImage}" alt="${user.userName}" class="${css.userPic}">
      <div class="${css.userName}">${user.userName}</div>
      ${dropdown(userLinks, {title: '', iconClass: css.iconInlineArrowDown, icon: icons.arrowDown})}
    </div>
  ` : `
    <div class="${css.languagePicker}">
      ${dropdown(languagesMenu(Object.keys(languages)), {title: t('choose_language'), iconClass: css.iconInlineGlobe, icon: icons.globe})}
    </div>
    <a href="${loginUrl(config)}" title="${t('title_signin')}" class="${css.signinButton}">${t('signin')}</a>
  `}
`;



// WEBPACK FOOTER //
// ./templates/header/desktop.js